/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useContext } from 'react';
import './settings.css';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import { sendRequest } from '../../api/shootAPI';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../utils/styledSelect';

const BTN_GHOST = 'inline-flex items-center justify-center box-border h-10 px-4 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition';
const BTN_GREEN = 'inline-flex items-center justify-center box-border h-10 px-4 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] transition';

function SamlField({ label, error, children }) {
  return (
    <div>
      <span className="block text-sm font-medium text-ink-900 mb-1.5">{label}</span>
      {children}
      {error ? <p className="text-xs text-[#CC4525] mt-1.5">{error}</p> : null}
    </div>
  );
}

function Authentication() {
  const { activeWorkspace, setActiveWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [checked, setChecked] = useState(activeWorkspace.authentication && activeWorkspace.authentication !== 'None');
  const [authentication, setAuthentication] = useState(activeWorkspace.authentication);
  const [samlConfig, setSamlConfig] = useState({
    samlEntryPoint: activeWorkspace.samlEntryPoint || '',
    samlIssuer: activeWorkspace.samlIssuer || '',
    samlCert: activeWorkspace.samlCert || '',
  });
  const [samlErrors, setSamlErrors] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const sendAuthenticationRequest = async (data) => {
    const res = await sendRequest({ method: 'put', url: API.WORKSPACE.authentication(activeWorkspace.id), data });
    if (res.success) {
      displayNotification({ message: 'Authentication has been set up successfully.', severity: 'success' });
      return true;
    }
    displayNotification({ message: 'An error occurs while setting up authentication. Please try again.', severity: 'error' });
    return false;
  };

  const handleChange = (event) => {
    const isChecked = event.target.checked;
    // eslint-disable-next-line no-nested-ternary
    const newAuthentication = isChecked ? (authentication !== 'None' ? authentication : 'Email') : 'None';
    setChecked(isChecked);
    setAuthentication(newAuthentication);
    setHasUnsavedChanges(true);
  };

  const handleSelectChange = (event) => {
    setAuthentication(event.target.value);
    setHasUnsavedChanges(true);
  };

  const handleSamlConfigChange = (field, value) => {
    setSamlConfig((prev) => ({ ...prev, [field]: value }));
    setHasUnsavedChanges(true);
  };

  const validateSamlConfig = () => {
    const errors = {};
    if (!samlConfig.samlEntryPoint) errors.samlEntryPoint = 'Entry Point URL is required';
    else if (!/^https?:\/\/.+/.test(samlConfig.samlEntryPoint)) errors.samlEntryPoint = 'Must be a valid URL starting with http:// or https://';
    if (!samlConfig.samlIssuer) errors.samlIssuer = 'Issuer/Entity ID is required';
    if (!samlConfig.samlCert) errors.samlCert = 'X.509 Certificate is required';
    else if (!samlConfig.samlCert.includes('BEGIN CERTIFICATE') || !samlConfig.samlCert.includes('END CERTIFICATE')) errors.samlCert = 'Certificate must include BEGIN CERTIFICATE and END CERTIFICATE headers';
    return errors;
  };

  const handleSaveChanges = async () => {
    setSamlErrors({});
    let data = { authentication };
    if (authentication === 'SAML') {
      const errors = validateSamlConfig();
      if (Object.keys(errors).length > 0) {
        setSamlErrors(errors);
        displayNotification({ message: 'Please fix the SAML configuration errors before saving.', severity: 'error' });
        return;
      }
      data = { ...data, ...samlConfig };
    }
    const res = await sendAuthenticationRequest(data);
    if (res) {
      setActiveWorkspace({ ...activeWorkspace, authentication, ...(authentication === 'SAML' ? samlConfig : {}) });
      setSamlErrors({});
      setHasUnsavedChanges(false);
    }
  };

  const handleDiscardChanges = () => {
    const originalAuth = activeWorkspace.authentication || 'None';
    setAuthentication(originalAuth);
    setChecked(originalAuth !== 'None');
    setSamlConfig({
      samlEntryPoint: activeWorkspace.samlEntryPoint || '',
      samlIssuer: activeWorkspace.samlIssuer || '',
      samlCert: activeWorkspace.samlCert || '',
    });
    setSamlErrors({});
    setHasUnsavedChanges(false);
  };

  const inputCls = (hasError) => `w-full box-border h-10 px-3 border rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none ${hasError ? 'border-[#CC4525]' : 'border-rule focus:border-brand-500'}`;
  const method = authentication && authentication !== 'None' ? authentication.toLowerCase() : 'email';

  return (
    <div style={{ maxWidth: 640 }}>
      <h4 className="text-base font-semibold text-ink-900 mb-1">Two-Factor Authentication</h4>
      <p className="text-sm text-ink-500 mb-4">Add an extra layer of security by requiring a second verification step for admins.</p>

      <label className="flex items-start gap-2.5 cursor-pointer">
        <input type="checkbox" checked={checked} onChange={handleChange} style={{ width: 16, height: 16, marginTop: 2, accentColor: '#3d5a8a', flexShrink: 0 }} />
        <span className="text-sm text-ink-900">{`Require two-factor authentication (via ${method}) for admins`}</span>
      </label>

      {checked && (
        <div className="mt-5 flex flex-col gap-4">
          <div>
            <span className="block text-sm font-medium text-ink-900 mb-1.5">Two-factor method</span>
            <select value={authentication} onChange={handleSelectChange} className={`${STYLED_SELECT_CLASS} w-full`} style={STYLED_SELECT_STYLE}>
              <option value="Email">Email (default)</option>
              <option value="Google Authenticator">Google Authenticator</option>
              <option value="SAML">SAML SSO</option>
            </select>
          </div>

          {authentication === 'Google Authenticator' && (
            <div className="rounded-[8px] p-3 text-xs text-ink-700" style={{ background: '#e8eef7' }}>
              <p className="mb-1"><strong className="text-ink-900">Note:</strong> Users will need an authenticator app (Google Authenticator, Authy, or Microsoft Authenticator) on their mobile device.</p>
              <p>Each user will see a QR code during their next login to complete setup.</p>
            </div>
          )}

          {authentication === 'SAML' && (
            <div className="flex flex-col gap-4">
              <p className="text-sm text-ink-700"><strong className="text-ink-900">SAML SSO Configuration.</strong> Configure your SAML identity provider settings below.</p>

              <SamlField label="SSO Entry Point URL *" error={samlErrors.samlEntryPoint}>
                <input
                  type="url"
                  className={inputCls(!!samlErrors.samlEntryPoint)}
                  style={{ borderStyle: 'solid', height: 40 }}
                  placeholder="https://your-idp.com/sso/saml"
                  value={samlConfig.samlEntryPoint}
                  onChange={(e) => handleSamlConfigChange('samlEntryPoint', e.target.value)}
                />
              </SamlField>

              <SamlField label="Issuer / Entity ID *" error={samlErrors.samlIssuer}>
                <input
                  type="text"
                  className={inputCls(!!samlErrors.samlIssuer)}
                  style={{ borderStyle: 'solid', height: 40 }}
                  placeholder="your-workspace-identifier"
                  value={samlConfig.samlIssuer}
                  onChange={(e) => handleSamlConfigChange('samlIssuer', e.target.value)}
                />
              </SamlField>

              <SamlField label="X.509 Certificate *" error={samlErrors.samlCert}>
                <textarea
                  rows="4"
                  className={`w-full box-border px-3 py-2 border rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none ${samlErrors.samlCert ? 'border-[#CC4525]' : 'border-rule focus:border-brand-500'}`}
                  style={{ borderStyle: 'solid', resize: 'vertical', fontFamily: 'monospace' }}
                  placeholder={'-----BEGIN CERTIFICATE-----\nMIICXjCCAcegAwIBAgIBADANBgkqhkiG9w0BAQ...\n-----END CERTIFICATE-----'}
                  value={samlConfig.samlCert}
                  onChange={(e) => handleSamlConfigChange('samlCert', e.target.value)}
                />
              </SamlField>

              <div className="rounded-[8px] p-3 text-xs text-ink-700" style={{ background: '#f1f2f5' }}>
                <p className="font-semibold text-ink-900 mb-1.5 text-sm">Service Provider Details</p>
                <p className="break-all"><span className="text-ink-500">Metadata URL: </span>{`${window.location.origin}/api/auth/saml/metadata/${activeWorkspace.id}`}</p>
                <p className="break-all"><span className="text-ink-500">ACS URL: </span>{`${window.location.origin}/api/auth/saml/callback/${activeWorkspace.id}`}</p>
              </div>
            </div>
          )}
        </div>
      )}

      {hasUnsavedChanges && (
        <div className="flex items-center gap-2 mt-6">
          <button type="button" onClick={handleDiscardChanges} className={BTN_GHOST} style={{ borderStyle: 'solid' }}>Cancel</button>
          <button type="button" onClick={handleSaveChanges} className={BTN_GREEN}>Save Changes</button>
        </div>
      )}
    </div>
  );
}

export default Authentication;
